import React, { PureComponent } from 'react';
import { base16Themes } from 'react-base16-styling';
import { ActionCreators, } from '@redux-devtools/core';
import deepmerge from 'deepmerge';
import reducer from './reducers.js';
import Chart from './Chart.js';
const { reset, rollback, commit, sweep, toggleAction } = ActionCreators;
const styles = {
    container: {
        fontFamily: 'monaco, Consolas, Lucida Console, monospace',
        position: 'relative',
        overflowY: 'hidden',
        width: '100%',
        height: '100%',
        minWidth: 300,
    },
};
function invertColors(theme) {
    return {
        ...theme,
        base00: theme.base07,
        base01: theme.base06,
        base02: theme.base05,
        base03: theme.base04,
        base04: theme.base03,
        base05: theme.base02,
        base06: theme.base01,
        base07: theme.base00,
    };
}
class ChartMonitor extends PureComponent {
    constructor() {
        super(...arguments);
        this.handleRollback = () => {
            this.props.dispatch(rollback());
        };
        this.handleSweep = () => {
            this.props.dispatch(sweep());
        };
        this.handleCommit = () => {
            this.props.dispatch(commit());
        };
        this.handleToggleAction = (id) => {
            this.props.dispatch(toggleAction(id));
        };
        this.handleReset = () => {
            this.props.dispatch(reset());
        };
    }
    getTheme() {
        const { theme, invertTheme } = this.props;
        if (typeof theme !== 'string') {
            return invertTheme ? invertColors(theme) : theme;
        }
        if (typeof base16Themes[theme] !== 'undefined') {
            return invertTheme
                ? invertColors(base16Themes[theme])
                : base16Themes[theme];
        }
        console.warn('DevTools theme ' + theme + ' not found, defaulting to nicinabox');
        return invertTheme
            ? invertColors(base16Themes.nicinabox)
            : base16Themes.nicinabox;
    }
    getChartOptions(props = this.props) {
        const { computedStates } = props;
        const theme = this.getTheme();
        const defaultOptions = {
            state: computedStates.length
                ? computedStates[props.currentStateIndex].state
                : null,
            isSorted: false,
            heightBetweenNodesCoeff: 1,
            widthBetweenNodesCoeff: 1.3,
            tooltipOptions: {
                disabled: false,
                offset: { left: 30, top: 10 },
                indentationSize: 2,
                styles: {
                    'background-color': theme.base06,
                    opacity: '0.7',
                    'border-radius': '5px',
                    padding: '5px',
                },
            },
            chartStyles: {
                width: '100%',
                height: '100%',
            },
            nodeStyleOptions: {
                colors: {
                    default: theme.base0B,
                    collapsed: theme.base0B,
                    parent: theme.base0E,
                },
                radius: 7,
            },
            textStyleOptions: {
                colors: {
                    default: theme.base0D,
                    hover: theme.base06,
                },
            },
        };
        return deepmerge(defaultOptions, props);
    }
    render() {
        const theme = this.getTheme();
        return (React.createElement("div", { style: { ...styles.container, backgroundColor: theme.base07 } },
            React.createElement(Chart, { ...this.getChartOptions() })));
    }
}
ChartMonitor.update = reducer;
ChartMonitor.defaultProps = {
    select: (state) => state,
    theme: 'nicinabox',
    preserveScrollTop: true,
    invertTheme: false,
};
export default ChartMonitor;
